import { render, staticRenderFns } from "./Change.vue?vue&type=template&id=a065a2cc&scoped=true&lang=pug&"
import script from "./Change.vue?vue&type=script&lang=js&"
export * from "./Change.vue?vue&type=script&lang=js&"
import style0 from "./Change.scss?vue&type=style&index=0&id=a065a2cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a065a2cc",
  null
  
)

export default component.exports